/* @ngInject */
function AssetPreviewFolderController ($scope) {
  const api = {}
  this.getApi = () => api

  activate()

  function activate () {
  }
}

export { AssetPreviewFolderController }
